export const WEIGHT_DELTA_CHANGE_MAX = 0.2;
export const WEIGHT_DELTA_CHANGE_MIN = -0.2;
